import { trackError } from '@if/core/telemetry'

export function reportErrorToConsole(error: unknown) {
  console.error(error)
}
export function reportErrorToServer(error: Error) {
  reportErrorToConsole(error)
  trackError(error)
}
